'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'users';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f0c0';
var svgPathData = ['M152 480c4.4 0 8-3.6 8-8l0-40c0-70.7 57.3-128 128-128l64 0c70.7 0 128 57.3 128 128l0 40c0 4.4 3.6 8 8 8l-336 0zm72-352c0-53 43-96 96-96 26.5 0 50.5 10.7 67.9 28.1 8.7 8.7 15.7 19 20.6 30.5 2.4 5.7 4.3 11.8 5.6 18 .6 3.2 1.1 6.4 1.5 9.7 .2 1.6 .3 3.2 .4 4.8 .1 1.5 .1 3.1 .1 5.1 0 3.5-.2 6.6-.5 9.7-.3 3.2-.8 6.4-1.5 9.5-1.3 6.2-3.2 12.3-5.6 18-4.9 11.5-11.9 21.8-20.6 30.5-17.4 17.4-41.4 28.1-67.9 28.1-53 0-96-43-96-96z', 'M320 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-208a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM288 304c-70.7 0-128 57.3-128 128l0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-40c0-79.5 64.5-144 144-144l64 0c79.5 0 144 64.5 144 144l0 40c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-40c0-70.7-57.3-128-128-128l-64 0zm143.4-61.2c3.9-3.8 7.7-7.9 11.2-12.1 11.2 5.9 23.9 9.2 37.4 9.2 44.2 0 80-35.8 80-80s-35.8-80-80-80c-2.4 0-4.8 .1-7.2 .3-1.6-5.3-3.6-10.4-5.7-15.5 4.2-.6 8.6-.9 12.9-.9 53 0 96 43 96 96s-43 96-96 96c-17.7 0-34.3-4.8-48.6-13.2zM160 64c4.4 0 8.7 .3 12.9 .9-2.2 5-4.1 10.2-5.7 15.5-2.4-.2-4.8-.3-7.2-.3-44.2 0-80 35.8-80 80s35.8 80 80 80c13.5 0 26.2-3.3 37.4-9.2 3.5 4.2 7.3 8.2 11.2 12.1-14.2 8.4-30.8 13.2-48.6 13.2-53 0-96-43-96-96s43-96 96-96zM503.8 320c-3.8-5.5-7.9-10.9-12.3-16l12.4 0c75.1 0 136 60.9 136 136l0 32c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-32c0-66.3-53.7-120-120-120l-.1 0zm-367.7 0l-.1 0C69.7 320 16 373.7 16 440l0 32c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-32c0-75.1 60.9-136 136-136l12.4 0c-4.3 5.1-8.4 10.5-12.3 16z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUsers = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;